import React, { useState, useEffect, useContext } from 'react';
import {
  ModalContainer, UIcon, IconContainer,
  MainContentContainer1, SubmitContainer,
  StyleButton, StyleInput, StyleLabel
} from '../Modal/CreateAdminUser';
import { FilterDropDown } from '../../../../ui-components';
import { useSettingModal } from '../../../../hooks/Context';
import apiCall from '../../../../utils/apiCall';
import { useMutation, useQueryClient } from "@tanstack/react-query";
import { NotificationContext } from '../../../../providers/notification';

interface EditInductionProps {
  induction: {
    InductionId: number;
    InductionName: string;
    InductionVenue: string;
    InductionDate: string;
    IsActive: boolean;
  };
}

const EditInduction = ({ induction }: EditInductionProps) => {
  const [InductionName, setInductionName] = useState('');
  const [InductionVenue, setInductionVenue] = useState('');
  const [date, setDate] = useState('');
  const [time, setTime] = useState('');
  const [isActive, setIsActive] = useState(false);
  const [loading, setLoading] = useState(false);

  const { showNotification } = useContext(NotificationContext);
  const { setShowModal } = useSettingModal();
  const queryClient = useQueryClient();

  useEffect(() => {
    if (induction) {
      setInductionName(induction.InductionName || '');
      setInductionVenue(induction.InductionVenue || '');
      const parsedDate = new Date(induction.InductionDate);

    const localDate = parsedDate.toISOString().split("T")[0];
    const localTime = parsedDate.toTimeString().slice(0, 5);

    setDate(localDate);
    setTime(localTime);
      setIsActive(induction.IsActive);
    }
  }, [induction]);

  const handleUpdateInduction = async () => {
   const InductionDate = `${date}T${time}:00`;

const data = {
  InductionId: induction.InductionId,
  InductionName,
  InductionVenue,
  InductionDate, // send string
  IsActive: isActive,
};

    setLoading(true);
    return (await apiCall().post('/SetUp/CreateUpdateInduction', data)).data;
  };

  const mutation = useMutation(handleUpdateInduction, {
    onSuccess: () => {
      showNotification({ type: 'success', message: 'Induction updated successfully' });
      setShowModal(false);
      queryClient.invalidateQueries(['all-Induction']);
    },
    onError: (error: any) => {
      showNotification({ type: 'error', message: error.message });
    },
    onSettled: () => setLoading(false),
  });

  const handleForm = (e: any) => {
    e.preventDefault();

    if (!InductionName || !InductionVenue || !date || !time) {
      showNotification({ type: 'error', message: 'All fields are required' });
      return;
    }

    mutation.mutate();
  };

  return (
    <ModalContainer>
     <div>
        <div>
          <div>
            <IconContainer><UIcon /></IconContainer>
            <span>Edit Induction</span>
          </div>
        </div>
        <MainContentContainer1 onSubmit={handleForm}>
          {/* <StyleLabel style={{ width: '100%' }}>
            <span>Induction Type</span>
            <FilterDropDown
              replace='true'
              options={[{ name: 'Induction', val: '1' }]}
              text='Induction type'
              border="1px solid lightgray"
              bg='white'
            />
          </StyleLabel> */}
          <StyleLabel>          
            <span>Name</span>
            <StyleInput value={InductionName} onChange={(e) => setInductionName(e.target.value)} />
          </StyleLabel>
          <StyleLabel>
            <span>Venue</span>
            <StyleInput value={InductionVenue} onChange={(e) => setInductionVenue(e.target.value)} />
          </StyleLabel>
          <StyleLabel>
            <span>Date</span>
            <StyleInput value={date} onChange={(e) => setDate(e.target.value)} type='date' />
          </StyleLabel>
          <StyleLabel>
            <span>Time</span>
            <StyleInput value={time} onChange={(e) => setTime(e.target.value)} type='time' />
          </StyleLabel>
          <StyleLabel>
            <span>Status</span>
            <select value={isActive ? 'true' : 'false'} onChange={(e) => setIsActive(e.target.value === 'true')}
                 style={{
                padding: '10px',
                border: '1px solid lightgray',
                borderRadius: '4px',
                width: '100%',
                }}>
              <option value="true">Active</option>
              <option value="false">Inactive</option>
            </select>
          </StyleLabel>
          <SubmitContainer>
            <span onClick={() => setShowModal(false)}>Cancel</span>
            <StyleButton type="submit">{!loading ? 'Update' : 'Updating...'}</StyleButton>
          </SubmitContainer>
        </MainContentContainer1>
      </div>
    </ModalContainer>
  );
};

export default EditInduction;
